import React, { useEffect, useState } from "react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { ShieldCheck, ChevronDown } from "lucide-react";

export default function VerifyBox({ shortId }) {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open && !data) api.get(`/calls/${shortId}/verify`).then(({ data }) => setData(data)).catch(() => {});
  }, [open, shortId, data]);

  return (
    <Collapsible open={open} onOpenChange={setOpen}>
      <CollapsibleTrigger data-testid="verify-toggle"
        className="w-full flex items-center justify-between border-2 border-ink bg-white h-11 px-4 btn-press shadow-brutal-sm font-bold text-sm">
        <span className="flex items-center gap-2"><ShieldCheck className="w-4 h-4" /> Verify receipt</span>
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </CollapsibleTrigger>
      <CollapsibleContent>
        {data && (
          <div className="border-2 border-t-0 border-ink bg-secondary p-4 text-xs font-mono space-y-2" data-testid="verify-content">
            <div><span className="text-muted-foreground">Call ID:</span> {data.short_id}</div>
            <div><span className="text-muted-foreground">Locked:</span> {fmtDateTime(data.locked_at)} ({data.timezone})</div>
            <div className="break-all"><span className="text-muted-foreground">{data.algorithm}:</span> {data.hash}</div>
            <p className="font-sans text-muted-foreground leading-relaxed pt-1">{data.explanation}</p>
          </div>
        )}
      </CollapsibleContent>
    </Collapsible>
  );
}
